module.exports = __webpack_public_path__ + "img/1.5e3d05d9.jpg";